// import { Operator } from '@kurtosys/ksys-app-template/dist/models/common';
import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	assetOverrides: {
		base: {
			dropdown: {
				caretDown: 'caretDown.svg',
				caretUp: 'caretUp.svg',
			},
			image: {
				logo: 'CTI_LOGO.png',
			},
		},
	},
	components: {
		app: {
			cardProps: {
				props: {
					footerContent: '',
					footerDisclaimers: {
						hasHtmlContent: true,
					},
					title: '',
				},
			},
			disabledActions: ['forgot-username'],
		},
		feedback: {
			steps: {
				codeInvalid: {
					backButtonText: 'Back to login',
					text: {
						queryOptionsType: 'none',
						value: 'The code you provided has not been recognised or has expired.',
					},
				},
				error: {
					backButtonText: 'Back to login',
					text: {
						queryOptionsType: 'none',
						value: 'Appears we have run into an error on our side, please reach out to the appropriate support channels.',
					},
				},
				userSuccess: {
					backButtonText: 'Back to login',
					text: {
						queryOptionsType: 'none',
						value: 'We have successfully updated your user',
					},
				},
				newUserRegistered: {
					backButtonText: 'Back to login',
					text: {
						queryOptionsType: 'none',
						value: 'New user request successful, please check your email for a link to set your password.',
					},
				},
				newUserRegisteredEmailSuppressed: {
					backButtonText: 'Back to login',
					text: {
						queryOptionsType: 'none',
						value: 'New user request submitted. Please contact your adminstrator for approval.',
					},
				},
			},
		},
		forgotPassword: {
			forgotPasswordButtonText: 'Send me a reset link',
			labelText: 'Email*',
			placeholderText: ' ',
		},
		mfaSetup: {
			backButtonIcon: {
				accessibilityText: 'Back to two factor method selection',
				asset: 'base.icons.backArrow',
			},
		},
		registrationConfirmation: {
			confirmationStatusText: {
				queryOptionsType: 'none',
				value: 'Please wait, while we confirm your registration.',
			},
			buttonOptions: {
				text: 'Confirm Registration'
			},
			confirmationLandingText: {
				queryOptionsType: 'none',
				value: 'Click here to confirm your registration'
			}
		},
		setPassword: {
			defaultOptions: {
				heading: 'Set Password',
				redirectOnSuccess: true,
			},
			modes: {
				password: {
					options: {
						buttonText: 'Change my password',
						confirmPasswordLabel: 'Confirm New Password',
						heading: 'Set your password',
						passwordLabel: 'New Password',
					},
					query: {
						code: 'param',
						key: 'param1',
						queryOptionsType: 'url',
						urlPattern: {
							queryOptionsType: 'none',
							value: '/:param1',
						},
					},
					value: {
						queryOptionsType: 'none',
						value: 'set-password',
					},
				},
				registration: {
					query: {
						code: 'queryString',
						key: 'type',
						queryOptionsType: 'url',
					},
					value: {
						queryOptionsType: 'none',
						value: 'self-registration',
					},
				},
			},
		},
		userLogin: {
			forgotPasswordButtonText: 'Forgot your password?',
			loginButtonText: 'Log in',
			passwordLabelText: 'Password*',
			passwordPlaceholderText: ' Password',
			redirectUrl: {
				queryOptionsType: 'none',
				value: '/adviser-edge/',
			},
			usernameLabelText: 'Username*',
			usernamePlaceholderText: ' Email address',
			registrationButtonOptions: {
				type: 'link',
				linkText: 'sign up',
			},
		},
	},
};
